import { useFormContext } from 'react-hook-form';
import { Box, Stack, Typography } from '@common-components';
import { useMount } from 'hooks';
import { messages } from 'i18n';
import FormEditor from 'components/hookFormComponents/FormEditor';
import { ComposeFromDraftProps } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/components/types';
import { insightsFormFieldsConfig } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/form-methods/config/insightsFieldsConfig';
import { InsightsFieldsNames } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/form-methods/enums';
import { QuotesList } from './QuotesList';

export default function ComposeFromDraft({ quotes, expiringPolicyFileId, savedDraft }: ComposeFromDraftProps) {
  const { setValue } = useFormContext();
  const { title } = messages.quoteComparisonPage.compose;
  useMount(() => {
    setValue(insightsFormFieldsConfig[InsightsFieldsNames.Insights].name, savedDraft.content);
  });

  return (
    <Stack pt={4} px={6} height={1}>
      <QuotesList quotes={quotes} expiringPolicyFileId={expiringPolicyFileId} />
      <Stack mt={3} height={1}>
        <Typography variant="body2Bold" component="div" mb={1}>
          {title}
        </Typography>
        <Box position="relative" height={1}>
          <FormEditor
            {...insightsFormFieldsConfig[InsightsFieldsNames.Insights]}
            excludeToolbarProps={['fontfamily']}
          />
        </Box>
      </Stack>
    </Stack>
  );
}
